import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_icon_home = _resolveComponent("icon-home")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_cards = _resolveComponent("icon-cards")!
  const _component_icon_megaphone = _resolveComponent("icon-megaphone")!
  const _component_icon_chat = _resolveComponent("icon-chat")!
  const _component_icon_users = _resolveComponent("icon-users")!
  const _component_icon_hat = _resolveComponent("icon-hat")!
  const _component_icon_video_corsi = _resolveComponent("icon-video-corsi")!
  const _component_icon_assistenza = _resolveComponent("icon-assistenza")!
  const _component_icon_clipboard = _resolveComponent("icon-clipboard")!
  const _component_icon_cart = _resolveComponent("icon-cart")!
  const _component_icon_shopping_bag = _resolveComponent("icon-shopping-bag")!
  const _component_icon_questionario = _resolveComponent("icon-questionario")!
  const _component_icon_faq = _resolveComponent("icon-faq")!
  const _component_icon_profilo = _resolveComponent("icon-profilo")!
  const _component_icon_documents = _resolveComponent("icon-documents")!

  return (_ctx.moduleConfig.name == 'Home')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/home",
        class: "nav"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Home",
              text: "Home"
            })
          ]),
          _createVNode(_component_icon_home, { class: "off" }),
          _createVNode(_component_icon_home, { class: "on" })
        ]),
        _: 1
      }))
    : (_ctx.moduleConfig.name == 'Cards')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/cards",
          class: "nav"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carte",
                text: "Carte"
              })
            ]),
            _createVNode(_component_icon_cards, { class: "off" }),
            _createVNode(_component_icon_cards, { class: "on" })
          ]),
          _: 1
        }))
      : (_ctx.moduleConfig.name == 'News')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/newsFeed",
            class: "nav"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "News",
                  text: "News"
                })
              ]),
              _createVNode(_component_icon_megaphone, { class: "off" }),
              _createVNode(_component_icon_megaphone, { class: "on" })
            ]),
            _: 1
          }))
        : (_ctx.moduleConfig.name == 'Chat')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: "/chat",
              class: "nav"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Chat",
                    text: "Chat"
                  })
                ]),
                _createVNode(_component_icon_chat, { class: "off" }),
                _createVNode(_component_icon_chat, { class: "on" })
              ]),
              _: 1
            }))
          : (_ctx.moduleConfig.name == 'Clienti')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: "/clienti",
                class: "nav"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Clienti",
                      text: "Clienti"
                    })
                  ]),
                  _createVNode(_component_icon_users, { class: "off" }),
                  _createVNode(_component_icon_users, { class: "on" })
                ]),
                _: 1
              }))
            : (_ctx.moduleConfig.name == 'Collaboratori')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: "/collaboratori",
                  class: "nav"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Collaboratori",
                        text: "Collaboratori"
                      })
                    ]),
                    _createVNode(_component_icon_hat, { class: "off" }),
                    _createVNode(_component_icon_hat, { class: "on" })
                  ]),
                  _: 1
                }))
              : (_ctx.moduleConfig.name == 'Corsi')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 6,
                    to: "/corsi",
                    class: "nav"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Corsi",
                          text: "Corsi"
                        })
                      ]),
                      _createVNode(_component_icon_video_corsi, { class: "off" }),
                      _createVNode(_component_icon_video_corsi, { class: "on" })
                    ]),
                    _: 1
                  }))
                : (_ctx.moduleConfig.name == 'Assistenza')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 7,
                      to: "/assistenza",
                      class: "nav"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Assistenza",
                            text: "Assistenza"
                          })
                        ]),
                        _createVNode(_component_icon_assistenza, { class: "off" }),
                        _createVNode(_component_icon_assistenza, { class: "on" })
                      ]),
                      _: 1
                    }))
                  : (_ctx.moduleConfig.name == 'Prenotazioni')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 8,
                        to: "/prenotazioni",
                        class: "nav"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Prenotazioni",
                              text: "Prenotazioni"
                            })
                          ]),
                          _createVNode(_component_icon_clipboard, { class: "off" }),
                          _createVNode(_component_icon_clipboard, { class: "on" })
                        ]),
                        _: 1
                      }))
                    : (_ctx.moduleConfig.name == 'Negozio')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 9,
                          to: "/shop",
                          class: "nav"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Negozio",
                                text: "Negozio"
                              })
                            ]),
                            _createVNode(_component_icon_cart, { class: "off" }),
                            _createVNode(_component_icon_cart, { class: "on" })
                          ]),
                          _: 1
                        }))
                      : (_ctx.moduleConfig.name == 'Acquisti')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 10,
                            to: "/acquisti",
                            class: "nav"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Acquisti",
                                  text: "Acquisti"
                                })
                              ]),
                              _createVNode(_component_icon_shopping_bag, { class: "off" }),
                              _createVNode(_component_icon_shopping_bag, { class: "on" })
                            ]),
                            _: 1
                          }))
                        : (_ctx.moduleConfig.name == 'Questionari')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 11,
                              to: "/questionari",
                              class: "nav"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Questionari",
                                    text: "Questionari"
                                  })
                                ]),
                                _createVNode(_component_icon_questionario, { class: "off" }),
                                _createVNode(_component_icon_questionario, { class: "on" })
                              ]),
                              _: 1
                            }))
                          : (_ctx.moduleConfig.name == 'Faq')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 12,
                                to: "/faq/0",
                                class: "nav"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "FAQ",
                                      text: "FAQ"
                                    })
                                  ]),
                                  _createVNode(_component_icon_faq, { class: "off" }),
                                  _createVNode(_component_icon_faq, { class: "on" })
                                ]),
                                _: 1
                              }))
                            : (_ctx.moduleConfig.name == 'Profilo')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 13,
                                  to: "/profile",
                                  class: "nav"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Profilo",
                                        text: "Profilo"
                                      })
                                    ]),
                                    _createVNode(_component_icon_profilo, { class: "off" }),
                                    _createVNode(_component_icon_profilo, { class: "on" })
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.moduleConfig.name == 'Documenti')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 14,
                                    to: "/documents",
                                    class: "nav"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_localized_text, {
                                          localizedKey: "Documenti",
                                          text: "Documenti"
                                        })
                                      ]),
                                      _createVNode(_component_icon_documents, { class: "off" }),
                                      _createVNode(_component_icon_documents, { class: "on" })
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.moduleConfig.isCustom)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 15,
                                      href: _ctx.moduleConfig.customUrl,
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$store.state.openBrowser && _ctx.$store.state.openBrowser(...args))),
                                      class: "nav"
                                    }, [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_localized_text, {
                                          localizedKey: _ctx.moduleConfig.customName,
                                          text: _ctx.moduleConfig.customName
                                        }, null, 8, ["localizedKey", "text"])
                                      ])
                                    ], 8, _hoisted_1))
                                  : _createCommentVNode("", true)
}